export class EmptyEnumClass{}
export enum TypeCheckEnum{
  Round,
  Square
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/drags/type-check/type-check-enum.ts